import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Setting, SettingConfig } from './setting'

export class SettingsRepository extends BaseRepository<Setting> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'settings', token, cache)
    }

    async updateFlags(entity: Partial<Setting>) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.eventApiUrl + '/settings/flags?token=' + this.resolvedToken,
            { flags: entity.flags },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getFlags() {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/settings/flags?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async updateConfigs(entity: Partial<SettingConfig>) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.eventApiUrl + '/settings/configs?token=' + this.resolvedToken,
            entity,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getConfigs() {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/settings/configs?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
